import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditServicePayload } from '@app-store/slices/services/editService'
import store from '@app-store/store'

interface TaskAction extends Action {
    payload: IEditServicePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.services.edit

function* editServiceSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/companies/services/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            store.dispatch(
                rootActions.services.list.editService({
                    id: payload.id,
                    data: { ...response.result, serviceImages: payload.serviceImages }
                })
            )
            if (payload.sagaCB) {
                yield payload.sagaCB?.onSuccess(response.result)
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editServiceSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editServiceSagaTask)
}

export default editServiceSaga
